
//
// Components

import Checkbox from './FormsComponents/Checkbox';
import InputAmount from './FormsComponents/InputAmount';
import InputCalendar from './FormsComponents/InputCalendar';
import Radio from './FormsComponents/Radio';
import SegmentButton from './FormsComponents/SegmentButton';

//
// Tools

import Ajax from '../tools/Ajax';
import Events from '../tools/Events';
import Constants from '../tools/Constants';

class Forms {
    
    constructor(aAjax){
        
        this.ajax = aAjax;

        this.forms = $('FORM.snookfun-form[data-key]');

        this.forms.each((aIndex, aElement) => {

            let form = $(aElement);

            let key = form.data('key');
            let autosubmit = form.data('autosubmit') == 1;

            if (!key) {
                console.error('Missing key on form');
            } else {
                console.info('Form ', key);
            }
            
            this.attachFormEvents(form);
            
            this.attachInputsInForm(form,autosubmit);

        });
        
    }
    
    attachFormEvents(aForm){
        
        let form = aForm;
        let key = form.data('key');

        form.on('submit', (event) => {

            // prevent submit
            event.stopPropagation();
            event.preventDefault();

            //fields
            let fields = form.serializeArray();

            Events.fire(Constants.Events.AJAX_FORM_REQUESTED,{
                formKey : key
            });

            Ajax.get(key, fields, (aResponse) => {
                
                Events.fire(Constants.Events.AJAX_FORM_RESPONDED,{
                    response : aResponse,
                    formKey : key
                });

            });
            
        });
        
    }

    attachInputsInForm(aForm,aAutoSubmit){

        let form = $(aForm);

        // InputAmount
        form.find('.snookfun-input-amount').each((aIndex, aElement) => {

            let input = new InputAmount(aElement);

            if(aAutoSubmit){
                input.onChange = (aName,aValue) => {
                    this.submitForm(form)
                };
            }

        });

        // SegmentButton
        form.find('.btn-group').each((aIndex, aElement) => {

            let segment = new SegmentButton(aElement);

            if(aAutoSubmit){
                segment.onChange = (aName,aValue) => {
                    this.submitForm(form)
                };
            }

        });

        // Checkbox
        form.find('.snookfun-form-checkbox').each((aIndex, aElement) => {

            let checkbox = new Checkbox(aElement);

            if(aAutoSubmit){
                checkbox.onChange = (aName,aValue) => {
                    this.submitForm(form)
                };
            }

        });
        
        // Radio
        form.find('.snookfun-form-radio').each((aIndex, aElement) => {

            let radio = new Radio(aElement);

            if(aAutoSubmit){
                radio.onChange = (aName,aValue) => {
                    this.submitForm(form)
                };
            }

        });
        
        // InputCalendar
        form.find('.snookfun-input-calendar').each((aIndex, aElement) => {
        	
        	let inputCalendar = new InputCalendar(aElement);

			if(aAutoSubmit){
				inputCalendar.onChange = (aName,aValue) => {
					this.submitForm(form)
				};
			}
        	
		});
        
    }

	submitForm(aForm){

		let form = $(aForm);

		form.submit();

	}

}

export default Forms;